import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='recruitment-campaign-intro'
    backgroundVariant='lightA'
    moduleName='intro-module'
    moduleVariation='A'
    themeType='lightTheme'
    // content
    headingText={<>Start fresh without <WidowBlock>starting over.</WidowBlock></>}
    introContent={(
      <Typography
        align='left'
        disableBottomPadding>
        You know you need a career change, but did you know that you don&#39;t have to start from scratch to make a meaningful pivot&#63; And that you likely already have the skills&#8212;like listening, relationship building, and drive&#8212;to be successful&#63; See what becoming a Northwestern Mutual financial advisor could do for you.
      </Typography>
    )}
  />
);

